import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, ArrowUpRight } from "lucide-react";

export default function AdminLogin() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const prev = document.title;
        document.title = "Gestão | O Homem da Obra";
        return () => { document.title = prev; };
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setErr(""); setLoading(true);
        try { await login(email.trim().toLowerCase(), password); nav("/admin"); }
        catch (e) { setErr(e?.response?.data?.detail || "Credenciais inválidas"); }
        finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen bg-[hsl(var(--forest))] flex items-center justify-center px-4 relative overflow-hidden">
            <div className="absolute inset-0 opacity-20" style={{ background: "radial-gradient(1200px 600px at 20% 10%, #B56D3B 0%, transparent 60%), radial-gradient(900px 500px at 80% 90%, #102520 0%, transparent 50%)" }} />
            <form onSubmit={submit} className="relative w-full max-w-md bg-[hsl(var(--cream))] rounded-2xl p-8 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.4)]" data-testid="admin-login-form">
                <Link to="/" data-testid="admin-login-logo" className="flex items-center gap-3 mb-8 group w-fit" aria-label="Voltar à página inicial">
                    <span className="logo-mark text-4xl text-[hsl(var(--forest))] group-hover:opacity-80 transition">H<span className="dot">.</span></span>
                    <div>
                        <div className="font-display font-bold text-stone-900 text-sm leading-none">O Homem da Obra</div>
                        <div className="text-[10px] uppercase tracking-widest text-[hsl(var(--copper))] font-mono mt-1">Painel de gestão</div>
                    </div>
                </Link>
                <h1 className="font-display text-2xl font-bold !text-stone-900 mb-2">Bem-vindo.</h1>
                <p className="text-sm !text-stone-600 mb-6">Aceda com as suas credenciais para gerir o site e os pedidos.</p>
                <label className="block mb-4">
                    <span className="block text-xs uppercase tracking-wider !text-stone-500 mb-2">Email</span>
                    <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email"
                        autoCapitalize="none" autoCorrect="off" spellCheck="false" inputMode="email" autoComplete="off" name="admin_login_email"
                        className="w-full px-4 py-3 rounded-lg bg-white border border-[hsl(var(--border))] !text-stone-900 focus:ring-2 focus:ring-[hsl(var(--copper))] outline-none" />
                </label>
                <label className="block mb-6">
                    <span className="block text-xs uppercase tracking-wider !text-stone-500 mb-2">Password</span>
                    <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password"
                        autoCapitalize="none" autoCorrect="off" spellCheck="false" autoComplete="new-password" name="admin_login_pw"
                        className="w-full px-4 py-3 rounded-lg bg-white border border-[hsl(var(--border))] !text-stone-900 focus:ring-2 focus:ring-[hsl(var(--copper))] outline-none" />
                </label>
                {err && <p className="text-red-700 bg-red-50 border border-red-200 text-sm mb-4 px-3 py-2 rounded-lg" data-testid="admin-login-error">{err}</p>}
                <button type="submit" disabled={loading} data-testid="admin-login-submit-btn"
                    className="btn-copper w-full justify-center disabled:opacity-50">
                    {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Entrar <span className="arrow-circle"><ArrowUpRight className="w-3.5 h-3.5" /></span></>}
                </button>
                <p className="text-xs text-[hsl(var(--muted-foreground))] mt-6 text-center">
                    Acesso restrito · nunca partilhe as suas credenciais.
                </p>
            </form>
        </div>
    );
}
